export const MuiSkeleton = {
    defaultProps: {
        variant: 'rounded',
    },
};
